import React from 'react';
import './ListItem.scss';

const ListItem = props => {
  const { className, changeHandler, clickHandler, style, checkedOptions } = props;
  return (
    <li className={className}>
      <div className="listItem" style={style} onClick={clickHandler}>
        <label>
          <input disabled checked={checkedOptions} type="checkbox" onChange={changeHandler} />
          {props.children}
        </label>
      </div>
    </li>
  );
};

export default ListItem;
